export default __webpack_public_path__ + "static/media/user-b.a7ee3e03.jpg";